import { ColumnInterface } from "components/tables/interfaces";
import Table from "components/tables/table";
import { ListEntity } from "models/list-entity";
import { ListUser } from "models/list-user";
import { Fragment, FunctionComponent, useState } from "react";
import { useList } from "stores/hooks/list";
import AddUserModal from "./add-user-modal";
import { useLocale } from "stores/hooks/locale";
import { useNavigate } from "react-router";
import { addUserColumns } from "lib/schema";
import { useTranslate } from "stores/hooks/translation";
import { faArrowUpRightFromSquare } from "components/icon-library";

interface UsersTableProps {
  users: ListUser[];
  listEntities: ListEntity[];
  onUpdate: () => Promise<void>;
}

const UsersTable: FunctionComponent<UsersTableProps> = ({
  users,
  listEntities,
  onUpdate,
}) => {
  const translate = useTranslate();
  const list = useList();
  const locale = useLocale();
  const navigate = useNavigate();
  const [addUserModal, toggleAddUserModal] = useState(false);

  if (!list) {
    return null;
  }

  // get columns
  const { schema = [] } = list;
  const columns: ColumnInterface[] = [];
  addUserColumns(schema, locale, listEntities, columns, translate);

  return (
    <Fragment>
      <Table
        name={`list-${list.uuid}-users`}
        columns={columns}
        data={users}
        noItemsText="Ei ilmoitusvelvollisia"
        adder={{
          text: "Lisää ilmoitusvelvollisia",
          onClick: async () => toggleAddUserModal(true),
        }}
        editers={[
          {
            icon: faArrowUpRightFromSquare,
            onClick: async (user: ListUser) =>
              navigate(`/admin/list/${list.uuid}/user/${user.uuid}`),
          },
        ]}
      />
      {addUserModal && (
        <AddUserModal
          list={list}
          onClose={async () => toggleAddUserModal(false)}
          onSubmit={onUpdate}
        />
      )}
    </Fragment>
  );
};

export default UsersTable;
